var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeisure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "park",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.25,
    height: 32.496,
    viewBox: "0 0 35.25 32.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_65318",
    "data-name": "Path 65318",
    d: "M80.688,247.506a.689.689,0,1,0-.487-.2A.694.694,0,0,0,80.688,247.506Zm0,0",
    transform: "translate(-74.492 -229.184)",
    fill: "#06233d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65319",
    "data-name": "Path 65319",
    d: "M28.425,18.1a4.751,4.751,0,1,0,2.789-8.972A7.608,7.608,0,1,0,16.151,7.608c0,.246.012.493.035.738a6.095,6.095,0,0,0-3.754,8.6H.95a.688.688,0,0,0,0,1.377H16.937v3.029H1.377V18.322H3.442a.688.688,0,0,0,0-1.377H.688A.688.688,0,0,0,0,17.634V22.04a.689.689,0,0,0,.688.688H2.754V25.2H.688A.688.688,0,0,0,0,25.887v2.754a.688.688,0,0,0,.688.688H2.754v1.79H.688a.688.688,0,0,0,0,1.377H30.844a.688.688,0,0,0,0-1.377h-.07c0-.074.007-.148.007-.222a3.94,3.94,0,0,0-6.333-3.133V21A5.2,5.2,0,0,0,28.425,18.1ZM14.039,16.945a4.713,4.713,0,0,1,3.033-7.391.688.688,0,0,0,.561-.8A6.231,6.231,0,1,1,29.99,7.608,6.223,6.223,0,0,1,29.68,9.55a.689.689,0,0,0,.682.9c.045,0,.091,0,.137,0a3.374,3.374,0,1,1-2.014,6.08.688.688,0,0,0-1.075.367A3.8,3.8,0,0,1,24.447,19.6V15.061l3.417-3.417a.688.688,0,1,0-.974-.974l-2.444,2.444V10.358a.688.688,0,0,0-1.377,0v4.417h0v.811L20.4,12.919a.688.688,0,0,0-.974.974l3.6,3.6c.014.013.028.026.042.038V19.6a3.752,3.752,0,0,1-2.086-1.145.688.688,0,0,0-.837-.133,4.71,4.71,0,0,1-1.834.566V17.634a.688.688,0,0,0-.688-.688H14.039Zm3.586,5.783a.689.689,0,0,0,.688-.688V20.272a6.106,6.106,0,0,0,2.038-.512A5.2,5.2,0,0,0,23.07,21V28.25a3.59,3.59,0,0,0-3.1,2.87H15.56v-1.79h2.065a.688.688,0,0,0,.688-.688V25.887a.688.688,0,0,0-.688-.688H15.56v-2.47Zm-13.494,0H14.183V25.2H4.131ZM1.377,26.575h15.56v1.377H1.377Zm2.754,2.754H14.183v1.79H4.131Zm20.62.073A2.566,2.566,0,0,1,29.4,30.9q0,.111-.01.222H21.389a2.208,2.208,0,0,1,2.636-1.451A.689.689,0,0,0,24.751,29.4Zm0,0",
    fill: "#06233d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_65320",
    "data-name": "Path 65320",
    d: "M335.778,101.826a.689.689,0,1,0-.487-.2A.693.693,0,0,0,335.778,101.826Zm0,0",
    transform: "translate(-312.02 -93.534)",
    fill: "#06233d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeisure);
export default __webpack_public_path__ + "static/media/leisure.574805a01ab9de165fef784875fabf45.svg";
export { ForwardRef as ReactComponent };